<template>
  <div id="tour_page">
    <!-- <BreadCrumb/> -->
    <CarouselImg :tour="tour"/>
    <TitlePart :tour="tour"/>
    <NavFixed :tour="tour" :registration="registration" />
    <IntroPart :tour="tour" :schedule="tour.schedule" :registration="registration" />
    <NoticePart :tour="tour" />
  </div>
</template>
<script>
// @ is an alias to /src
import CarouselImg from '@/components/CarouselImg.vue'
import TitlePart from '@/components/TitlePart.vue'
import NavFixed from '@/components/NavFixed.vue'
import IntroPart from '@/components/IntroPart.vue'
import NoticePart from '@/components/NoticePart.vue'
export default {
  components: {
    CarouselImg,
    NoticePart,
    TitlePart,
    NavFixed,
    IntroPart
  },
  data () {
    return {
      data_eachday: [{
        id: '',
        date: '2022-11-10',
        departure_place: '台北',
        min_people: '4',
        max_people: '30',
        ps: '日期備註',
        signup_people: '20',
        available_people: '10',
        room: {
          double: { quantity: '0', available: 4 },
          triple: { quantity: '0', available: 0 },
          four: { quantity: '0' },
          five: { quantity: '0' },
          six: { quantity: '0' }
        }
      }],
      // schedule: [],
      // content: {},
      tour: {
        quotation: [],
        subcategoryUrl: '',
        available_date: [{ dates: [] }],
        price_img: [],
        noticeSelect: ['', '', '', ''],
        noticeInput: ['', '', '', ''],
        schedule: []
      },
      registration: [],
      metaData: [],
      metaTitle: '',
      // id: '99',
      share: {
        copyUrl: 'https://tstar888.com/JP2TW/product/',
        fb: 'https://www.facebook.com/sharer/sharer.php?kid_directed_site=0&sdk=joey&u=https%3A%2F%2Ftstar888.com%2FJP2TW%2F%3Fid%3DJPN22001&display=popup&ref=plugin&src=share_button'
      }
    }
  },
  metaInfo () {
    const title = this.metaTitle
    const meta = this.metaData
    return { title, meta }
    // return {
    //   title: this.metatitle,
    //   meta: meta
    // }
  },
  methods: {
  },
  async created () {
    // 如果此連結帶有推薦代碼，記住推薦碼
    if (this.$route.name === 'TourPageRef') {
      this.$store.commit('setReferrer', this.$route.params.ref_code)
    }
    const tourId = this.$route.params.id
    // 旅行團
    try {
      const { data } = await this.api.post('php_modules2/tour.php?type=r&id=' + tourId)
      console.log(data)
      // 如果查無旅遊團ID，則跳轉至NotFound頁面
      if (!data.success) {
        this.$router.push('/notfound')
        return
      } else if (!data.data[0].sell && !this.$store.state.jwt) { // 擋一般人進到沒有上架的頁面(登入者可進入)
        this.$router.push('/')
        return
      } else this.tour = data.data[0]
      this.$i18n.locale = this.tour.language // 改變語言環境
      // this.schedule = data.data[0].schedule
      // this.content = data.data[0].content

      // 三張圖的元件，版型style改成3
      for (let i = 0; i < this.tour.schedule.length; i++) {
        if (this.tour.schedule[i].hotel.img.length === 3) {
          this.tour.schedule[i].hotel.style = 3
        }
      }
      this.tour.schedule.forEach(day => {
        if (day.hotel.img.length === 3) day.hotel.style = 3
        day.spots.forEach(spot => {
          if (spot.img.length === 3) spot.style = 3
        })
      })
      this.tour.data_eachday = this.data_eachday
      // 在這裡把tour的meta帶進資料裡，因為metaInfo ()不能直接用this.tour.metaInfo...
      this.metaTitle = this.tour.metaInfo.title
      this.metaData.push({
        vmid: 'description',
        name: 'description',
        content: this.tour.metaInfo.description
      },
      {
        vmid: 'keyword',
        name: 'keyword',
        content: this.tour.metaInfo.keywords
      })
    } catch (error) {
      this.$swal({
        icon: 'error',
        title: '錯誤',
        text: '讀取旅行團選項失敗' + error
      })
    }
    // 搜索該團子分類的ID，產生連到這團子分類的站內連結
    try {
      const { data } = await this.api.post('php_modules2/category.php?type=r1&recommended=true&language=' + this.$i18n.locale)
      // console.log(data)
      data.data.forEach((c) => {
        if (c.title === this.tour.category) {
          c.child.forEach(item => {
            if (item.title === this.tour.subcategory) {
              this.tour.subcategoryUrl = item.id
            }
          })
        }
      })
      // console.log(this.tour.subcategoryUrl)
    } catch (error) {
      this.$swal({
        icon: 'error',
        title: '錯誤',
        text: error
      })
    }
    // 讀取單一出團日
    try {
      const { data } = await this.api.post('php_modules2/tour_registration.php?type=r&tourId=' + tourId)
      console.log(data, '單一出團日')
      if (data.status) {
        this.registration = data
      } else {
        console.log('沒出團資料false')
      }
    } catch (error) {
      this.$swal({
        icon: 'error',
        title: '錯誤',
        text: error
      })
    }

    if (this.tour.quotation.length > 0) {
      this.tour.quotation.forEach((quotation, index) => {
        // 版單把keyName 改成key 才能正常顯示field
        this.tour.quotation[index].quotationsFields = quotation.quotationsFields.map(item => {
          const { keyName, ...rest } = item
          return { ...rest, key: keyName }
        })
        this.tour.quotation[index].quotationsFields.push({ key: 'hotel', label: '飯店' }, { key: 'golf', label: '球場' })
        // 隱藏沒有上架的團
        const indexesToRemove = []
        quotation.tourQuotation.forEach((tour, tourindex) => {
          if (!tour.sell) { indexesToRemove.push(tourindex) }
        })
        indexesToRemove.reverse().forEach((indexToRemove) => {
          this.tour.quotation[index].tourQuotation.splice(indexToRemove, 1)
        })
      })
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
}
</script>

<style lang="scss">
#tour_page{
  .jp2twstyle {
    display: none;
    font-family: 'Noto Sans JP', sans-serif !important;
  }
  @media (min-width:992px) {
    .container {
      max-width: 860px !important;
    }
  }
  @media (min-width:1200px) {
    .container {
      max-width: 980px !important;
    }
  }
}
.shareLink {
  align-items: flex-end;
  user-select: none;
  -webkit-user-select: none; /* for Chrome、Safari */
  -moz-user-select: none;  /* for Mozilla、Firefox */
  transition: .5s;
  font-weight: bold;
  // top: 97.5%;
  left: -145px;
  bottom: 0px;
  position: fixed;
  // background-color: aquamarine;
  z-index: 999;
  font-size: .8rem;
  display: flex;
  flex-direction: column;
  div {
    border: 1px solid;
    padding: 2px;
    border-radius: 5px;
    background-color: aliceblue;
  }
  & img {
    width: 80%;
    border-radius: 5px;
    cursor: pointer;
    margin-bottom: 2px;
  }
  &:hover {
    // transform: translate(60px, -141px);
    transform: translate(115px, 0px);
  }
}
</style>
